/**
* @name: query-tool-bar
* @author: weiyong
* @date: 2023-07-13 11:37
* @description：query-tool-bar
* @update: 2023-07-13 11:37
*/
<template>
  <div class="xmTimeLine"
       v-if="vuex['showCtl']!==false"
       :data-flow-log-key="timeLineInstanceKey"
       :class="[props.cardHoverShadow?'cardHoverShadow':'',props.paddingSize]"
       :style="[elCtlStyle,elBaseStyle,xmTimeLineSty]">
    <a-form-item-rest>
      <a-skeleton v-if="loadingFlag" active :paragraph="{ rows: 8 }"/>
      <div v-else class="trachDynamic" style="padding: 20px;">
        <a-timeline :mode="props.position">
          <a-timeline-item v-for="item in tableDs">
            <template v-if="dataConfig.templateKey==='commonList'">
              <common-list :flowDealFlag="props.flowDealFlag" @cardClick="cardClick" :dataConfig="dataConfig" :props="props" :record="item"/>

              <div class="right-panel-slot filterCtl" @click.stop v-if="dataConfig.hasRightSlot&&props.rightSlotItem">
                <xm-div-ctl
                    :props="props.rightSlotItem.props"
                    :showLabel="false"
                    :eventParams="{inParams:{record:item},inParamsInfo:[{label:'当前点击记录',value:'record'}]}"
                    pId="right-panel-slot"
                    :styles="props.rightSlotItem.styles"
                    :model="props.rightSlotItem.model"
                    :events="props.rightSlotItem.events"
                    :id="props.rightSlotItem.key"
                    :elConfig="props.rightSlotItem"
                    :pItem="elConfig"/>
              </div>
            </template>

          </a-timeline-item>
          <a-empty v-if="tableDs.length===0" :image="simpleImage"/>
        </a-timeline>
        <audio ref="audioPlayerRef"
               src="http://146.56.212.210:30026/api/xm-telephone/public/mock/audio/2024-05-09/1715244634068.mp3"></audio>
      </div>
    </a-form-item-rest>
  </div>
</template>

<script lang="ts">
import {defineAsyncComponent, defineComponent} from 'vue';

const componentParam = {
  xmDivCtl: defineAsyncComponent(
      () => import("@/main-page-base/ctls/containers/xmDiv/index.vue")
  ),
};

export default defineComponent({
  components: {
    ...componentParam,
  },
  name: "xmTimeLineCtl",
});
</script>

<script lang="ts" setup>
import {Timeline as ATimeline,TimelineItem as ATimelineItem, FormItemRest as AFormItemRest,Empty as AEmpty,Skeleton as ASkeleton} from "ant-design-vue";
import CommonList from './contentTempSel/commonList/index.vue';
import {useCtlStyle} from "@/main-page/hooks/useCtlStyle";
import {Empty} from 'ant-design-vue';
import {useVuexState} from "@/main-page/ctls/hooks/useVuexState";
import {useDataDealHooks} from "@/main-page-base/ctls/dataCtls/xmCardList/hooks/useDataDealHooks";
import {useAudioPlayHooks} from "@/main-page/components/hooks/useAudioPlayHooks";
import {unref} from "vue";
import {useComEvent} from "@/main-page/ctls/hooks/useComEvent";
import {useGridTableStoreCtl} from "@/main-page/ctls/hooks/useGridTableStoreCtl";
import eventBus from "@/events/eventBus";
import GoingUtils from "@/utils/goingUtils";

const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;


interface propTypes {
  rowSelColor: boolean,
  pId: string,
  props: any,
  events: any,
  readOnlyText: boolean,
  showLabel: boolean,
  pModelObj: any,
  list: any,
  model: any,
  pItemFormKey: string,
  pItem:string,
  queryParams: any,
  dataConfig: any,
  elConfig: any,
  styles:any,
}

const propsPage = withDefaults(defineProps<propTypes>(), {
  pId: '',
  showLabel: true,
  pModelObj: {},
  readOnlyText:false,
  styles:{},
  list: {},
  rowSelColor: false,
  queryParams: {},
  pItem:'',
  events: [],
  props: {},
  pItemFormKey: '',
  model: {},
  dataConfig: {},
  elConfig: {}
})
const {queryParams, autoLoad, dataConfig, props, styles, model, events}: any = propsPage;
const {elConfig}=propsPage;

const {vuex} = useVuexState({sectionConfig: props, vuexProps: ['showCtl', 'disabled']});
const eventParams = [{label: '查询参数集', value: 'queryParams'}];
const {elCtlStyle, elBaseStyle} = useCtlStyle({
  styles,
  props,
  propsStyl: ['width'],
  outExtendProp: ['height', 'paddingLeft', 'paddingRight']
});
const xmTimeLineSty = computed(() => {
  const sty = {};
  if ((unref(props).height + '').indexOf("%") >= 0 || (unref(props).height + '').indexOf("auto") >= 0) {
    sty['height'] = unref(props).height;
  } else {
    sty['height'] = unref(props).height + 'px';
  }
  return sty;
})

if (unref(props).contentConfigs) {
  unref(props).contentConfigs.baseConfig = false;
  unref(props).contentConfigs.styles = {};
}

const emits = defineEmits({})
//数据集合处理
const {
  initCtlDataFun,
  loadingFlag,
  pageTotal,
  flushList,
  tableDs,
  showLoading
} = useDataDealHooks({emits, events, dataConfig, props, queryParams});
const {initStoreCtl} = useGridTableStoreCtl({props, dataConfig, ctlType: 'xmTimeLine'});
initStoreCtl(initCtlDataFun);

const timeLineInstanceKey = computed(() => {
  return String(unref(elConfig)?.key || unref(props)?.key || '').trim();
});

const flushTimeLine = () => {
  flushList({});
};

const timeLineEventKeys = () => {
  const outerKey = timeLineInstanceKey.value;
  return outerKey ? [outerKey] : [];
};

onMounted(() => {
  if (unref(dataConfig) && unref(dataConfig).autoLoadData !== false) {
    initCtlDataFun({});
  }
  timeLineEventKeys().forEach((k) => {
    eventBus.on(k + '_flushFlowLog', flushTimeLine);
    eventBus.on(GoingUtils.getEventCtlKey(k) + '_flushFlowLog', flushTimeLine);
  });
})

onBeforeUnmount(() => {
  timeLineEventKeys().forEach((k) => {
    eventBus.off(k + '_flushFlowLog', flushTimeLine);
    eventBus.off(GoingUtils.getEventCtlKey(k) + '_flushFlowLog', flushTimeLine);
  });
});

const audioPlayerRef = ref(null);
const record = ref({});
const {playAudio, audioFilePath, audioEnded, stopAudio} = useAudioPlayHooks({audioPlayerRef, record});

const isPlayFlag = ref(false);
const clickEventFun = () => {
  if (!unref(isPlayFlag)) {
    playAudio();
    isPlayFlag.value = true;
  } else {
    stopAudio();
    isPlayFlag.value = false;
  }
}

const {clickEvent, viewModel} = useComEvent({events});
//当前卡片点击事件
const cardClick = (item) => {
  clickEvent('click', {record: unref(item)});
}

defineExpose({
  flushList,
  initCtlDataFun,
});
</script>

<style type="text/css" lang="less">


</style>
